export type Environment = 'development' | 'qa' | 'uat' | 'production'

export const getEnvironment = (): Environment => {
  const env = process.env.NEXT_PUBLIC_ENVIRONMENT || process.env.NODE_ENV

  return (env as Environment) || 'development'
}

export const isProduction = (): boolean => getEnvironment() === 'production'
